import React from "react";

/** Numbered section divider — forms read top-down as clear steps. */
export const SectionHead: React.FC<{ num: number; title: string; hint?: string }> = ({ num, title, hint }) => (
	<div className="flex items-center gap-3 pt-1">
		<span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-primary/30 bg-primary/5 text-xs font-bold text-primary">
			{num}
		</span>
		<h2 className="text-base font-bold">{title}</h2>
		{hint && <span className="hidden text-xs text-muted-foreground sm:inline">{hint}</span>}
		<div className="h-px flex-1 bg-border" />
	</div>
);
